import { getInstance } from "../../core/axios-gateway";
import {
  TAgentConnection,
  TAgentConnectionListResponse,
  TAgentConnectionResponse,
  TUpdateConnectionRequest,
} from "../../types/connection";

const BASE_PATH = "/api/agents/v1/connections";

export const getConnections = async (supplierId: string) => {
  return getInstance()
    .get<TAgentConnectionListResponse>(BASE_PATH, {
      params: { tenantId: supplierId },
    })
    .then((res) => res.data);
};

export const getConnectionById = async (
  connectionId: string,
  supplierId: string
) => {
  return getInstance()
    .get<TAgentConnectionResponse>(`${BASE_PATH}/${connectionId}`, {
      params: { tenantId: supplierId },
    })
    .then((res) => res.data);
};

export const updateConnection = async (
  connectionId: string,
  supplierId: string,
  data: TUpdateConnectionRequest
) => {
  return getInstance()
    .put<TAgentConnectionResponse>(`${BASE_PATH}/${connectionId}`, data, {
      params: { tenantId: supplierId },
    })
    .then((res) => res.data);
};

